import React from 'react';

import Typography from '@mui/material/Typography';

export const Features = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        height: 600,
      }}
    >
      <div style={{ margin: '3em' }}>
        <Typography variant="h4" component="h4" fontStyle="bold">
          What we do
        </Typography>
        <Typography marginTop="40px">
          We manage a property wait list so that a new direct booking quickly
          follows any cancellation / vacancy.
        </Typography>
      </div>
      <div style={{ display: 'flex', padding: '1em' }}>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            borderRadius: '30px',
            margin: 20,
            height: 350,
          }}
        >
          <img src="./assets/no-vacancy.svg" height={170} />
          <span style={{ padding: 10 }}>
            When there are no vacancies for your property
          </span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            borderRadius: '30px',
            margin: 20,
            height: 350,
          }}
        >
          <img src="./assets/todo.svg" height={170} />
          <span style={{ padding: 10 }}>
            Customers gets directed to your property RezyList waitlist
          </span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            borderRadius: '30px',
            margin: 20,
            height: 350,
          }}
        >
          <img src="./assets/cancel.png" height={150} />
          <span style={{ padding: 10 }}>Cancellations lead to open rooms</span>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'white',
            borderRadius: '30px',
            margin: 20,
            height: 350,
          }}
        >
          <img src="./assets/hotel.svg" height={200} />
          <span style={{ padding: 10 }}>
            The RezyList system immeditely identifies the open room and matches
            a RezyList guest to book directly at your hotel
          </span>
        </div>
      </div>
    </div>
  );
};
